<template>
  <el-row v-if="amReady">
    <div class="mb-5 border-bottom">
      <h3>{{ ((!editMode) ? $ml.get('create') : $ml.get('edit')) + ' ' + module.info.caption }}</h3>
    </div>
    <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
      <dg-text-field
          :control="controller"
          :field_span="22"
            :label_span="22"
          :translateLabel="false"
          field_mark="required"
          label="outbound Prefix"
          name="outbound_prefix"
          placeholder="921"
          rules="required"></dg-text-field>

      <dg-select-field
          :control="controller"
          :field_span="22"
            :label_span="22"
          :options="voipDestinationsList"
          :translateLabels="false"
          field_mark="required"
          label="destination"
          labelProperty="label"
          valueProperty="label"
          htmlautocomplete="new-password"
          name="destination"
          rules="required"
          ></dg-select-field>
    </el-col>
    <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
      <dg-text-field
          :control="controller"
          :field_span="22"
            :label_span="22"
          field_mark="required"
          :translateLabel="false"
          label="destination Data"
          name="bc_destination_data"
          placeholder="200"
          rules="required"
          type="text"></dg-text-field>

      <dg-select-field
          :control="controller"
          :field_span="22"
            :label_span="22"
          :options="fusionServerList"
          :translateLabels="false"
          field_mark="required"
          label="fusion_server"
          name="pbx_server_url"
          rules="required"></dg-select-field>
    </el-col>

    <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
      <dg-text-field
          :control="controller"
          :field_span="22"
            :label_span="22"
          field_mark="required"
          :translateLabel="false"
          label="Caller ID"
          name="bc_caller_id_number"
          placeholder="001 9421 8273 56"
          rules="required"></dg-text-field>

      <dg-select-field
          :control="controller"
          :field_span="22"
            :label_span="22"
          :options="voipCallTestTypesList"
          :defaultValue="5"
          :translateLabels="false"
          field_mark="required"
          label="test_type"
          name="call_test_type"
          rules="required"></dg-select-field>
    </el-col>

    <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
      <dg-select-field
          :control="controller"
          :field_span="22"
            :label_span="22"
          :options="vendorsList"
          :translateLabels="false"
          field_mark="required"
          :translateLabel="false"
          label="vendor Name"
          labelProperty="label"
          valueProperty="value"
          htmlautocomplete="new-password"
          name="vendor_name"
          rules="required"
      ></dg-select-field>
    </el-col>

    <el-col :class="$langConfig.cssClass" :span="(!editMode)? 24 : 24">
      <dg-text-field
          :control="controller"
          :field_span="22"
            :label_span="22"
          field_mark="required"
          label="phone_numbers"
          name="bc_phone_numbers"
          placeholder="secret"
          rules="required"
          rows="5"
          type="textarea"></dg-text-field>
    </el-col>

    <el-col :span="24" class="mt-5 border-top" v-loading="loadingRequests">
      <el-col :class="$langConfig.cssClass" :span="20" class="mt-4">
        <dg-label-field class="error-field-validate-message" label="fields_do_not_match_the_required_criteria"
                        v-show="!this.validData"></dg-label-field>
      </el-col>
      <el-col :span="4" class="pt-3 text-right">
        <dg-button
            :click="createModule"
            :text="actionButtonLabel"
            :type="actionButtonType"
            icon="el-icon-phone mr-2"></dg-button>
      </el-col>
    </el-col>
  </el-row>
</template>

<script>

import voipDestinationsList from '@/json/voipDestinationList.json'
import voipCallTestTypesList from '@/json/voipCallTestTypesList.json'

import iziToast from 'izitoast'
import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
import module from './../index.js'

export default {
  mixins: [fieldController],
  props: {
    editMode: {
      required: true,
      type: Boolean
    },
    onEditCallback: {
      required: false
    },
    onCreateCallback: {
      required: false
    }
  },
  data() {
    return {
      vendorsList: [],
      voipDestinationsList: voipDestinationsList,
      voipCallTestTypesList: voipCallTestTypesList,
      controller: this,
      amReady: true,
      module: {
        ...module
      },
      dataModel: {},
      fusionServerList: []
      /*fusionServerList: [
        {
          'label': 'London',
          'value': '142.12.44.90'
        },
        {
          'label': 'Singapora',
          'value': 'https://mrttester.space/ https://206.189.146.252'
        },
        {
          'label': 'New Singapora',
          'value': 'https://128.199.136.157'
        },
        {
          'label': 'London / Mrttester.com',
          'value': 'https://mrttester.com'
        }
      ]*/
    }
  },
  computed: {
    ...$mapState('ajaxManager', ['loadingRequests']),
    actionButtonIcon: function () {
      if (!this.editMode) {
        return 'el-icon-phone';
      } else {
        return 'el-icon-phone-outline'
      }
    },
    actionButtonLabel: function () {
      if (!this.editMode) {
        return 'make_test';
      } else {
        return 're-test'
      }
    },
    actionButtonType: function () {
      if (!this.validData) {
        return 'danger';
      } else {
        return 'primary app-bg-primary'
      }
    }
  },
  beforeMount() {
    this.getVendorDropDownList().then( (r) => {
      this.vendorsList = r
    })
    this.getFusionsDropDownList().then( (r) => {
      this.fusionServerList = r
    })
  },
  methods: {
    ...$mapActions('voip-vendor-api', { getVendorDropDownList: 'getDropDownList'}),
    ...$mapActions('voip-fusion-server-api', {getFusionsDropDownList: 'getDropDownList'}),
    createModule() {
      this.validateFields().then(result => {
        let context = this;
        let data = {data: this.dataModel};
        if (this.editMode) {
          data.id = this.dataToBind.id;
        }

        if (result) {
          let api = (this.editMode) ? 'update' : 'callTestRequest';
          this.$store.dispatch(this.module.info.name + '-api/' + api, data).then(response => {
            iziToast.success({
              title: this.$ml.get('successfully'),
              message: '',
              position: 'topRight',
              close: false,
              timeout: 1900,
              animateInside: true
            });
            return

            this.amReady = false

            if (context.editMode) {
              context.onEditCallback(response.data)
            } else {
              $vue.nextTick(() => {
                context.amReady = true
              })
              if (context.onCreateCallback) {
                context.onCreateCallback(response.data)
              }
            }
            // this.$router.push({ name: this.module.stateName + '-module-list', params: { teacherId: response.data.id}}).then( response => {})
          }).catch(error => {
            this.setfieldsErrorMessage({
              fieldsErrors: error.response.data
            }, this.arefieldsValid);
          })
        }
      })
    }
  }
}
</script>
